import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../../global/env';
import { AuditLogReportRequest, LoginLogoutRow } from '../../model/auditlogreports';

const fetchLoginLogoutData = async (request: AuditLogReportRequest): Promise<LoginLogoutRow[]> => {
  const url = Config.auditReportsBaseURL + 'Login';
  const { data } = await axios.post(url, request);
  //@ts-ignore
  const rows: LoginLogoutRow[] = data.map(item => new LoginLogoutRow(item));
  return rows;
}

const useLoginLogout = (request: AuditLogReportRequest) => {
  return useQuery<LoginLogoutRow[], Error>(['LoginLogouts', request], () => fetchLoginLogoutData(request));
}

export default useLoginLogout;
